export default defineNuxtPlugin((nuxtApp) => {
   const $config = nuxtApp.$config;
   const authStore = useAuthStore();
   const { getAuthed, getToken } = storeToRefs(authStore);
   const { getStorage } = useLocalStorage();
   const { catcher } = useErrorHelper();
   const { logInfo, logError } = useDebugger();
   const token = computed(() => getToken.value ?? getStorage("auth/token"));
   const authed = computed(() => getAuthed.value ?? getStorage("auth/authed"));
   const hasSession = useCookie("session");

   // console.log("API plugin initialized with token:", token.value, "and authed:", authed.value);
   const $apiFetch = $fetch.create({
      baseURL: $config.public.apiUrl,
      onRequest({ request, options, error }) {
         if ((authed.value && token.value) || hasSession.value) {
            options.headers.set(
               "Authorization",
               `Bearer ${token.value ?? hasSession.value}`,
            );
         }
      },
      onResponse({ response }) {
         logInfo("onResponse ", {
            endpoint: response.url,
            status: response?.status,
         });
         // check for 401
         // if (process.client && response?.status === 401) {
         //    catcher(response);
         // }
      },
      async onResponseError({ response, ...error }) {

         logError("onResponseError ", {
            endpoint: response?.url,
            status: response?.status,
            error: response?._data?.error,
            message: response?._data?.error?.message ?? response?._data?.message,
         });
         await catcher(response);
      },
   });
   nuxtApp.provide("apiFetch", $apiFetch);
});

declare module "#app" {
   interface NuxtApp {
      $apiFetch: typeof $fetch;
   }
}
